import { io } from 'socket.io-client';
import { authHeader } from './auth-header';
import { proxy } from './proxy';

export { saveImg, listFiles, exportWithFiles,  createPosition,updatePosition, deletePosition, getSinglePosition, getSingleStore, assignUserToPosition, assignUserToStore, getPositionsByClient };

async function handleResponse(response) {
    return await response.text().then((text) => {
        let data = text;
        try {
            data = text && JSON.parse(text);
        } catch (error) {
            console.error('cannot convert String to JSON', error);
        }
        if (!response.ok) {
            if (response.status == 401) {
                // auto logout if 401 response returned from api
                //logout();
                //location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}

async function saveImg(fileInput, filePath) {
    const formData = new FormData();

    for (var i = 0; i < fileInput.length; i++) {
        formData.append(`files`, fileInput[i].content, fileInput[i].name);
    }
    formData.append(`filePath`, filePath);

    let result = await fetch(`${proxy}/files/upload`, {
        method: 'POST',
        headers: {
            ...authHeader(),
            Accept: 'application/json',
        },
        body: formData,
    });
    return result;
}

async function listFiles(from) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ from }),
    };
    let result = await fetch(`${proxy}/files/list`, requestOptions);
    return result;
}

async function exportWithFiles(id, actionName, setState, alertExport) {

    const socket = io(proxy);

    socket.on('progress-' + id, ({ type, progress }) => {
        setState((s) => ({ ...s, [type]: progress }));
    });

    setState((s) => ({ ...s, exporting: true, progress: 0 }));
    const requestOptions = {
        method: 'Get',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };
    try {
        const response = await fetch(`${proxy}/exportWithFiles/${id}`, requestOptions);
        if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${actionName} ${new Date().toLocaleDateString()}.zip`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            alertExport('Exportdatei erfolgreich heruntergeladen!');
            setState((s) => ({ ...s, exporting: false, exportSuccessfull: true }));
            socket.disconnect();
        } else {
            alertExport('Datei konnte nicht heruntergeladen werden');
            setState((s) => ({ ...s, exporting: false, exportSuccessfull: false }));
            socket.disconnect();
        }
    } catch (error) {
        console.error('Error:', error);
        alertExport('Datei konnte nicht heruntergeladen werden');
        setState((s) => ({ ...s, exporting: false, exportSuccessfull: false }));
        socket.disconnect();
    }
}


async function createPosition(position, successCallback, errorCallback) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify( position ),
    };
    const response = await fetch(`${proxy}/positions`, requestOptions);
     handleResponse(response).then(
        (resp) => successCallback?.(resp)
        ,
        (error) => errorCallback?.(error)
    );
}
async function updatePosition(position, successCallback, errorCallback) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify( position ),
    };
    const response = await fetch(`${proxy}/positions`, requestOptions);
     handleResponse(response).then(
        (resp) => successCallback?.(resp)
        ,
        (error) => errorCallback?.(error)
    );
}

async function deletePosition(position, successCallback, errorCallback) {
    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify( position ),
    };
    fetch(`${proxy}/positions`, requestOptions).then(resp=>{
        successCallback?.()
    }).catch(err=>{
        errorCallback?.()
    });
}

async function assignUserToPosition(id, userId, request, success, failure) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };
    request?.()
    const response = await fetch(`${proxy}/positions/assignUser/${id}/users/${userId}`, requestOptions);
    
    handleResponse(response).then(
        (resp) => success?.(resp)
        ,
        (error) => failure?.(error)
    );
}

async function assignUserToStore(id, userId, request, success, failure) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };
    request?.()
    const response = await fetch(`${proxy}/stores/assignUser/${id}/users/${userId}`, requestOptions);
     handleResponse(response).then(
        (resp) => success?.(resp)
        ,
        (error) => failure?.(error)
    );
}

async function getSinglePosition(id, request, success, failure) {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };
    request?.()
    const response = await fetch(`${proxy}/positions/${id}`, requestOptions);
    
    handleResponse(response).then(
        (resp) => success?.(resp)
        ,
        (error) => failure?.(error)
    );
}

async function getSingleStore(id, request, success, failure) {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };
    request?.()
    const response = await fetch(`${proxy}/stores/${id}`, requestOptions);
    
    handleResponse(response).then(
        (resp) =>{
           if (resp == 'error' || resp.response == null){
            failure?.("error")}
            else{
                success?.(resp.response)
            }
           
         }
        ,
        (error) => failure?.(error)
    );
}

async function getPositionsByClient(filter, request, success, failure) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify( filter ),
    };
    request?.()
    const response = await fetch(`${proxy}/positions/withFilter`, requestOptions);
    handleResponse(response).then(
        (resp) => success?.(resp)
        ,
        (error) => failure?.(error)
    );
}
